<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="currentcolor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.33317 29.3337V26.0003L13.3332 23.2003V18.4003L2.6665 22.667V18.667L13.3332 11.2003V5.33366C13.3332 4.60033 13.5943 3.97255 14.1165 3.45033C14.6387 2.9281 15.2665 2.66699 15.9998 2.66699C16.7332 2.66699 17.3609 2.9281 17.8832 3.45033C18.4054 3.97255 18.6665 4.60033 18.6665 5.33366V11.2003L29.3332 18.667V22.667L18.6665 18.4003V23.2003L22.6665 26.0003V29.3337L15.9998 27.3337L9.33317 29.3337Z"
    />
  </svg>
</template>
<script>
export default {};
</script>
